import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { Box, Chip } from "@mui/material";
import { GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import { useParams } from "react-router-dom";
import CustomDataGridV2 from "../../../../../../../components/CustomDataGridV2";
import RenderWithTooltip from "../../../../../../../components/RenderWithTooltip";
import { useGetTwilioRecordedAudio } from "../../../../../../../queries/twilio/use-get-recorded-twilio-audio";
import { formatDateTime } from "../../../../../../../utils/date-time-utility";
import PopOverCreator from "../../../../../../../utils/util-components/PopOverCreator";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  applyDefaultColumnSettings,
} from "../../../../../../../utils/utils";

const PatientCallTable = () => {
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);
  const { patientId } = useParams() as { patientId: string };

  const {
    data: callList,
    isLoading: tableDataLoading,
    isRefetching: tableRefetching,
  } = useGetTwilioRecordedAudio({
    searchString: undefined,
    gridSorting,
    pagination,
    patientUuid: patientId,
  });

  const COLUMNS = applyDefaultColumnSettings<any>([
    {
      field: "userName",
      flex: 0.6,
      minWidth: 100,
      disableColumnMenu: true,
      headerName: "From",
      renderCell: ({ value }) => <RenderWithTooltip value={value} />,
    },
    // {
    //   field: "userName",
    //   headerName: "To",
    //   flex: 0.3,
    //   minWidth: 100,
    //   renderCell: ({ value }) => (
    //     <RenderWithTooltip value={value} />
    //   ),
    // },
    {
      field: "callType",
      headerName: "Call Type",
      flex: 0.5,
      minWidth: 70,
      renderCell: ({ value }) => (
        <Chip label={value} size="small" variant="outlined" />
      ),
    },
    {
      field: "duration",
      headerName: "Duration",
      flex: 0.5,
      minWidth: 70,
      renderCell: ({ value }) => (value ? value - 1 + " Sec." : "-"),
    },
    {
      field: "recordingAt",
      flex: 0.7,
      minWidth: 140,
      headerName: "Recording Date & Time",
      renderCell: ({ value }) => (
        <RenderWithTooltip value={value ? formatDateTime(value) : "-"} />
      ),
    },
    {
      field: "recordingFile",
      flex: 0.2,
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      headerName: "Call Recording",
      renderCell: ({ value }) => <AudioPlayer filePath={value} />,
    },
  ]);

  const AudioPlayer = ({ filePath }: { filePath: string }) => {
    return (
      <PopOverCreator
        triggerComponent={<PlayCircleOutlineIcon fontSize="small" />}
        contentComponent={
          <audio controls autoPlay>
            <source src={filePath} type="audio/wav" />
            Your browser does not support the audio element.
          </audio>
        }
      />
    );
  };

  return (
    <Box height={"100%"}>
      <CustomDataGridV2
        rows={callList?.data?.content ?? []}
        getRowId={(row) => row?.uuid}
        rowCount={callList?.data.page.totalElements}
        loading={tableDataLoading || tableRefetching}
        columns={COLUMNS}
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
        onSortModelChange={setGridSorting}
      />
    </Box>
  );
};

export default PatientCallTable;
